<template>
    <div class="row items-center">
        <q-field style="width: 300px;">
            <q-input
                v-model="!editMode ? currentOwnerName : newOwnerName"
                @click="editOwner"
                @focus="$event => selectText($event)"
                @blur="applyChanges"
                :loading="loading"
                placeholder="Введите ФИО/Email клиента"
                ref="input"/>
            <q-btn icon="clear" @click="discardChanges" flat round color="primary" class="field-edit-button">
                <q-tooltip>Отменить редактирование</q-tooltip>
            </q-btn>
            <q-popover v-model="searchOpened" :no-focus="true" :no-refocus="true" :anchor-click="false" anchor="bottom left" self="top left"
                       :offset="[0, -5]" max-height="300px">
                <q-infinite-scroll :handler="loadMoreUsers" :offset="20">
                    <q-list no-border>
                        <q-item v-for="(user, index) in usersList" :key="index" @click.native="changeOwner(user)" link>
                            {{user.first_name}} {{user.last_name}} <{{user.email}}>
                        </q-item>
                    </q-list>
                    <div class="row justify-center">
                      <q-spinner-dots v-show="loading" :size="25"/>
                    </div>
                </q-infinite-scroll>
                <div v-if="!usersList.length" class="q-ma-md">
                    <span style="font-style: italic; font-size: 12px;">Клиент не найден</span>
                </div>
                <div class="q-ma-md">
                    <q-btn @click="createNewUser" label="Добавить нового клиента"/>
                </div>
            </q-popover>
        </q-field>
        <q-btn :disable="!canSave" icon="save" @click="applyChanges" flat round>
            <q-tooltip>Сохранить</q-tooltip>
        </q-btn>
        <q-btn v-if="owner" @click="this.window.open('/users/' + ownerId, '_blank')" icon="call_made" flat round>
            <q-tooltip>Открыть страницу клиента</q-tooltip>
        </q-btn>
        <project-user-letter-toggler
            v-if="owner"
            :user="owner"
        />
        <user-create v-model="newUserModalOpened" @create="user => changeOwner(user)" @close="$refs.input.focus()" />
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

  import UserCreate from '@/UserCreate'

  import {
    QField,
    QInput,
    QBtn,
    QTooltip,
    QPopover,
    QList,
    QItem,
    QInfiniteScroll,
    QSpinnerDots
  } from 'quasar';
  import ProjectUserLetterToggler from "../ProjectUsersList/ProjectUserLetterToggler";

  export default {
    name: "ProjectOwner",
    components: {
      ProjectUserLetterToggler,
      QField,
      QInput,
      QBtn,
      QTooltip,
      QPopover,
      QList,
      QItem,
      QInfiniteScroll,
      QSpinnerDots,
      UserCreate
    },
    computed: {
      ...mapState({
        project: state => state.project.data,
        owner: state => _.cloneDeep(state.project.data.owner),
      }),
      currentOwnerName () {
        return this.owner ? `${this.owner.first_name} ${this.owner.last_name} <${this.owner.email}>` : null
      },
      ownerId() {
        return this.owner ? this.owner.id : null
      },
    },
    watch: {
      newOwnerName(value) {
        clearTimeout(this.inputDelayTimer);

        if (value === this.currentOwnerName || this.newOwnerName === this.ownerTempName) {
          return;
        }

        if (value.length >= 2) {
          this.inputDelayTimer = setTimeout(() => {
            this.query = value;
            this.usersList = [];
            this.usersListPage = 1;
            this.findUser(value);
          }, this.inputDelay);
        } else {
          this.searchOpened = false;
        }
      }
    },
    data() {
      return {
        editMode: false,
        searchOpened: false,
        newOwnerName: null,
        newOwnerId: null,
        newOwnerData: '',
        query: '',
        usersList: [],
        usersListPage: 1,
        usersListPagesCount: 1,
        canSave: false,
        loading: false,
        ownerTempName: null,
        newUserModalOpened: false,
        inputDelay: 500,
        inputDelayTimer: null
      }
    },
    methods: {
      editOwner () {
        this.editMode = true;
        this.newOwnerName = this.currentOwnerName;
      },
      applyChanges (e) {
        if (e.relatedTarget && e.relatedTarget.classList.contains('q-popover')) {
          return;
        }

        if (this.newOwnerName === this.currentOwnerName || !this.editMode || !this.newOwnerData || this.newUserModalOpened) {
          this.canSave = false;
          return;
        }

        this.saveChanges();
      },
      discardChanges () {
        this.editMode = false;
      },
      saveChanges () {
        this.loading = true;
        this.newOwnerData["users"] = {
          is_owner: true,
          receive_letters: true,
        }

        this.$store.commit('project/setProjectOwner', this.newOwnerData);
        this.$store.commit('project/setProjectOwnerId', this.newOwnerId);
        this.editMode = false;
        this.$http.put(`api/v1.0/projects/${this.$route.params.id}`, this.project).then((response) => {
          this.$q.notify({
            message: `Сохранено`,
            type: 'info',
            position: 'bottom'
          });
          this.canSave = false;
          this.loading = false;

          this.$store.commit('project/setUsers', response.data.users)
          this.$store.commit('project/setManagers', response.data.users)
        }).catch((error) => {
          _.forIn(error.response.data.errors, (value, key) => {
            this.$q.notify(value[0]);
          })
        });
      },
      findUser (query, page = 1) {
        this.loading = true;
        return this.$http.get(`api/v1.0/users/?filter[role]=user&filter[search]=${query}&page=${page}`).then(response => {
          this.usersList = [ ...this.usersList, ...response.data.users];
          this.usersListPagesCount = response.data.pagesCount;
          this.searchOpened = true;
          this.loading = false;
        });
      },
      loadMoreUsers (_i, done) {
        if (this.usersListPagesCount > this.usersListPage) {
          this.findUser(this.query, ++this.usersListPage).then(() => done());
        } else {
          done();
        }
      },
      changeOwner (owner) {
        this.newOwnerName = this.ownerTempName = `${owner.first_name} ${owner.last_name} <${owner.email}>`;
        this.newOwnerId = owner.id;
        this.newOwnerData = owner;
        this.searchOpened = false;
        this.canSave = true;

        setTimeout(() => {
          this.$refs.input.focus();
          this.$refs.input.$refs.input.select();
        })
      },
      selectText ($event) {
        $event.target.select();
      },
      createNewUser () {
        this.$emit('setUserLastName', this.newOwnerName);
        this.searchOpened = false;
        this.newUserModalOpened = true;
      },
    }
  }
</script>

<style scoped>
    .q-btn.disabled {
        opacity: 0.2 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectOwner/ProjectOwner.vue